import BaseService from '@/features/BaseService';

export default class EventTypeService extends BaseService {
  constructor() {
    super('event-types');
  }
}



// WEBPACK FOOTER //
// ./src/features/event-type/EventTypeService.js